import React, {
    CSSProperties,
    PropsWithChildren,
    ReactNode,
    forwardRef,
    useEffect,
    useRef,
    useState,
} from "react";
import "./LayoutPlus.less";

export interface LayoutPlusProps {
    header?: ReactNode;
    className?: string;
}

const LayoutPlus = (props: PropsWithChildren<LayoutPlusProps> , ref) => {

    const [marginBottom, setMarginBottom] = useState(0);
    const headref = useRef(null)

    useEffect(() => {
        const element = headref.current;
        if (element) {
            setMarginBottom(element.clientHeight)
        }
        const resizeObserver = new ResizeObserver(() => {
            setMarginBottom(element.clientHeight)
        })
        resizeObserver.observe(element)
        return () => {
            resizeObserver.disconnect()
        }
    }, [])

    const contentStyle = {
        "--layout-plus-content-bottom-offset": `${marginBottom}px`,
    } as CSSProperties;

    return (<div className={`layout-plus ${props?.className || ""}`}>
        <div className="layout-plus-header" ref={headref}>
            {props?.header}
        </div>
        <div className="layout-plus-body" ref={ref}>
            <div className="layout-plus-content" style={contentStyle}>
                {props?.children}
            </div>

        </div>
    </div>)
}


export default forwardRef(LayoutPlus)
